module.exports = __webpack_public_path__ + "client/img/s_item_14.6ee8df2b.png";